import { css, styled } from 'styled-components';

import { CommonAction, designColor, recipesCommonAction, styledMedia, styledTypography } from '@pkg/primitives';

import { tokens } from './FilterAction.tokens.ts';

interface ActionProps {
    $iconOnly?: boolean;
}

export const Action = styled(CommonAction)<ActionProps>`
    ${recipesCommonAction.basic};
    gap: ${tokens.gap}px;
    padding-left: ${tokens.padding}px;
    padding-right: ${tokens.padding}px;
    min-width: ${tokens.height}px;
    height: ${tokens.height}px;
    background-color: rgb(255, 255, 255, 0.1);

    &:disabled {
        opacity: 0.8;
    }

    &:hover:not(:active) {
        background-color: rgba(255, 255, 255, 0.16);
    }

    &[aria-pressed] {
        background-color: ${designColor.brandPurple};

        &:hover:not(:active) {
            background-color: ${designColor.brandPurpleDark};
        }
    }

    ${({ $iconOnly }) =>
        $iconOnly &&
        css`
            padding: 0;
        `};
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.fontSize}px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.iconSize}px;
    height: ${tokens.iconSize}px;
`;
